import {defineMessages} from 'react-intl';

export default defineMessages({
	productsToReturn: {
		id: 'returnAuthCreateForm.step2.productsToReturn',
		defaultMessage: 'Products to return',
	},
	productsToReturnNumber: {
		id: 'returnAuthCreateForm.step2.productsToReturnNumber',
		defaultMessage: 'Products to return: {products}',
	},
	productsToExchangeNumber: {
		id: 'returnAuthCreateForm.step2.productsToExchangeNumber',
		defaultMessage: 'Products to exchange: {products}',
	},
	productsToRefundNumber: {
		id: 'returnAuthCreateForm.step2.productsToRefundNumber',
		defaultMessage: 'Products to refund: {products}',
	},
	amountToRefund: {
		id: 'returnAuthCreateForm.step2.amountToRefund',
		defaultMessage: 'Amount to refund: ',
	},
	createButtonText: {
		id: 'returnAuthCreateForm.step2.continueButton.text',
		defaultMessage: 'Confirm return'
	},
	backToProductSelection: {
		id: 'returnAuthCreateForm.step2.backToProductSelection',
		defaultMessage: 'Back to Product selection'
	},
	title: {
		id: 'returnAuthCreateForm.step2.title',
		defaultMessage: 'Return products',
	},
	reasonToReturn: {
		id: 'returnAuthCreateForm.step2.reasonToReturn',
		defaultMessage: 'Reason to return',
	},
});
